import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import { useModal } from "../contexts/ModalContext";
import BodyContent from "../Modulos/Republicas/BodyContent";

const NewRepublica = () => {

    const { openModal } = useModal();

    const openSideBar = () => {

        openModal('sidebarOverlay');

    }

    return (
        <>
            <NavBar title="REPÚBLICAS" setSideBar={ openSideBar } />
            <GenericBody>
                <BodyContent />
            </GenericBody>
        </>
    )

}

export default NewRepublica;